//
import { mapActions, mapState } from 'vuex'
import {
    ModelAutocomplete,
    ModelDataTable,
} from '@/components/reusable_components/next'
import xlsxUtils from '@/mixins/XlsxUtils'

//
import KardexModel from '@/models/Warehouse/WhKardex'
import WhProductClean from '@/models/Warehouse/WhProductClean'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'product-list',
    components: {
        'model-autocomplete': ModelAutocomplete,
        'crud-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        autocompleteProps() {
            return {
                model: WhProductClean,
            }
        },

        /**
         *
         */
        currentParams() {
            return {
                filter: this.$refs.table ? this.$refs.table.currentFilter : {},
                get_all_results: true,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: KardexModel,
                filters: filters({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                }),
                headers,
                paramFilter: {
                    wh_product_id: this.product,
                },
            }
        },

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            product: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        mapExcel(item) {
            return {
                Fecha: String(item.created_at),
                Producto: String(item.wh_product_name),
                Bodega: String(item.wh_warehouse_name),
                'Saldo Anterior': Number(item.stock_before),
                'Saldo Posterior': Number(item.stock_after),
            }
        },

        /**
         *
         */
        mapExcelDetailed(item) {
            return {
                Fecha: String(item.created_at),
                Producto: String(item.wh_product_name),
                Bodega: String(item.wh_warehouse_name),
                'Venta Sala': Number(item.normal_sale_total),
                'Venta Terreno': Number(item.ground_sale_total),
                'Ajuste Terreno': Number(item.stock_adjust_total),
                'Compras Terreno': Number(item.purchase_order_total),
                Reenvasado: Number(item.repacking_total),
                'Call Center': Number(item.call_center_sale_total),
                'Venta Empleado': Number(item.employee_sale_total),
                'Consumo Interno': Number(item.internal_consumption_total),
                'Cambio Producto': Number(item.change_product_customer_total),
            }
        },

        /**
         *
         */
        printExcel(res) {
            this.generateXLSX(
                res.data.map(this.mapExcel),
                [],
                'Reporte de movimiento de stock'
            )
        },

        /**
         *
         */
        printExcelDetailed(res) {
            this.generateXLSX(
                res.data.map(this.mapExcelDetailed),
                [],
                'Reporte detallado de movimiento de stock'
            )
        },

        /**
         *
         */
        submitExcel() {
            KardexModel.modeler()
                .params(this.currentParams)
                .where('wh_product_id', this.product)
                .get()
                .then(this.printExcel)
        },

        /**
         *
         */
        submitExcelDetailed() {
            KardexModel.modeler()
                .params(this.currentParams)
                .where('wh_product_id', this.product)
                .where('report', true)
                .get()
                .then(this.printExcelDetailed)
        },
    },
    mixins: [xlsxUtils],
    beforeMount() {
        this.setTitleTopBar('Tarjetas de existencia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_MOVEMENT_INVENTORY')) ctx.$router.push('/')
        })
    },
}
